import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'common-card',
  props: {
    topLogo: null,
    bottomlogo: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})